import React from "react";
import { FormattedMessage } from "react-intl";

import { Avatar } from "@sincro/react-avatar";
import {
  Card,
  CardHeader,
  CardTitle,
  CardText,
  CardActions
} from "@sincro/react-card";
import { Chip, ChipLeadingIcon, ChipText } from "@sincro/react-chips";
import { TrackedElement } from "@sincro/react-tracked-element";

import { makePascalCase } from "../analytics/AnalyticsUtil";
import { icons } from "@sincro/react-global-header-and-navigation";

export class ApplicationCard extends React.Component {
  render() {
    const { apps = [] } = this.props;

    return (
      <div className="applications">
        {apps.map(app => {
          const appIcon = icons[app.code];

          return (
            <TrackedElement
              key={app.code}
              type={`navigate|${makePascalCase(app.name)}`}
              name="DCC|MyApplications"
            >
              <CardActions key={app.code} className="sincro-application-card">
                <a href={app.targetUrl}>
                  <Card key={app.code} className="dcc-container-dark">
                    <CardHeader>
                      <div className="app-card-meta">
                        <Avatar>
                          {appIcon && <img src={appIcon} alt={app.code} />}
                        </Avatar>
                        {app.mobileReady && (
                          <Chip>
                            <ChipLeadingIcon>smartphone</ChipLeadingIcon>
                            <ChipText>
                              <FormattedMessage
                                id="Dcc.mobileReady"
                                defaultMessage="Mobile Ready"
                              />
                            </ChipText>
                          </Chip>
                        )}
                      </div>
                      <CardTitle>{app.name}</CardTitle>
                    </CardHeader>
                    <CardText>{app.description}</CardText>
                  </Card>
                </a>
              </CardActions>
            </TrackedElement>
          );
        })}
      </div>
    );
  }
}
